<template>
  <div class="cont-xw">
    <div class="jg-head">产品应用</div>
    <img class="img-responsive center-block" src="../../common/images/RH07.jpg">
    <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
          
    <ul>
       
    </ul>
  </div>
</template>

<script>
import { riseup } from "@/common/js/riseup.js";
export default {
  data() {
    return {};
  },
 methods: {

    riseup() {
        riseup()
      }

      
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/RH/07.vue